export default __webpack_public_path__ + "static/media/Pawdopt.bf3935e4.webp";